export default class Routes {
  static root = {
    name: 'root',
    path: '/'
  };

  static register = {
    name: 'register',
    path: '/register'
  };

  static registerSmall = {
    name: 'registerSmall',
    path: '/registerSmall'
  };

  static registerSmallLight = {
    name: 'registerSmallLight',
    path: '/registerSmallLight'
  };

  static registerSuccessfull = {
    name: 'registerSuccessfull',
    path: '/registerSuccessfull'
  };

  static resetPassword = {
    name: 'resetPassword',
    path: '/reset'
  };

  static dashboard = {
    name: 'dashboard',
    title: 'header.nav.dashboard.title',
    path: '/dashboard'
  };

  static management = {
    name: 'management',
    title: 'header.nav.management.title',

    accounts: {
      path: '/management/accounts',
      name: 'accounts',
      title: 'header.nav.management.accounts'
    },
    licenses: {
      path: '/management/licenses',
      name: 'licenses',
      title: 'header.nav.management.licenses'
    },
    activations: {
      path: '/management/activations',
      name: 'activations',
      title: 'header.nav.management.activations'
    }
  };

  static mailSender = {
    name: 'mailSender',
    title: 'header.nav.mailSender.title',
    path: '/mailsender'
  };

  static reports = {
    name: 'reports',
    title: 'header.nav.reports.title',
    accountsLog: {
      path: '/reports/accounts',
      name: 'accountsLog',
      title: 'header.nav.reports.accountsLog'
    },
    licenseLog: {
      path: '/reports/license',
      name: 'licenseLog',
      title: 'header.nav.reports.licenseLog'
    },
    activationLog: {
      path: '/reports/activation',
      name: 'activationLog',
      title: 'header.nav.reports.activationLog'
    },
    errorsLog: {
      path: '/reports/errors',
      name: 'errorsLog',
      title: 'header.nav.reports.errorsLog'
    },
    mailLog: {
      path: '/reports/mail',
      name: 'mailLog',
      title: 'header.nav.reports.mailLog'
    }
  };

  static ReturnUrl = 'return-url';
}
